import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react"
import { deleteNegotiationById, Negotiation } from "src/apis/negotiation";
import NoDataAlert from "src/pages/components/NoDataAlert";
import TableActionsCell from "src/pages/components/TableActionsCell";
import { isUserAdministrator } from "src/utils/auth";
import { Id } from "src/utils/types";

type NegotiationsTableProps = {
  negotiations: Negotiation[],
}

const NegotiationsTable: FC<NegotiationsTableProps> = ({ negotiations }): JSX.Element => {
  const hasNegotiations = useMemo(() => Boolean(negotiations) && negotiations.length > 0, [negotiations]);
  const [entries, setEntries] = useState(negotiations);

  const removeEntry = (entryId: Id) => {
    const newEntries = entries?.filter((e) => e.id !== entryId);

    setEntries(newEntries)
  }

  useEffect(() => {
    if (hasNegotiations) {
      setEntries(negotiations)
    }
  }, [hasNegotiations, negotiations])

  return hasNegotiations ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Empresa</strong></TableCell>
            <TableCell><strong>Negociação</strong></TableCell>
            {isUserAdministrator() && (
              <TableCell><strong>Ações</strong></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {entries?.map((negotiation: Negotiation) => (
            <TableRow>
              <TableCell>{negotiation?.id}</TableCell>
              <TableCell>{negotiation?.empresa}</TableCell>
              <TableCell>{negotiation?.negociacao}</TableCell>
              {isUserAdministrator() && (
                <TableActionsCell
                  editUrl={`/negociacao/${negotiation.id}/editar`}
                  deleteCallback={async () => {
                    if (window.confirm(`Deseja mesmo deletar essa negociação (ID ${negotiation?.id})? Essa ação não poderá ser desfeita`)) {
                      await deleteNegotiationById(negotiation.id);

                      removeEntry(negotiation?.id);
                    }
                  }}
                />
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataAlert />
  );
}

export default NegotiationsTable;
